import FinancialReportingDetailsSearchForm from "../components/FinancialReporting/FinancialReportDetailsSearchForm";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, Application, KeyValue, Query } from "../interfaces";
export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
    currentApp: appState.app as Application,
    uuid: appState.uuid,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (
      filter: string,
      value: string | string[] | KeyValue[] | boolean,
    ) => {
      dispatch(actions.updateUi(filter, value));
      dispatch(actions.searchPush());
    },
    updateFilters: (filter: string, value: string | string[]) => {
      dispatch(actions.updateFilter(filter, value));
      dispatch(actions.searchPush());
    },
    resetState: (state: Query) => {
      dispatch(actions.resetState(state));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinancialReportingDetailsSearchForm);
